import { Media } from "@Utilities/Media";
import enquire from "enquire.js";

export class Layout
{
	private CollapseEvent: string;
	private Description: HTMLElement;
	private DescriptionContainerDesktop: HTMLElement;
	private DescriptionContainerMobile: HTMLElement;
	private Includes: HTMLElement;
	private SizeChart: HTMLElement;

	constructor()
	{
		this.CollapseEvent = "show.bs.collapse";
		this.Description = document.querySelector("#prdDesc");
		this.DescriptionContainerDesktop = document.querySelector("#prdDesc_dt");
		this.DescriptionContainerMobile = document.querySelector("#prdDesc_mo");
		this.Includes = document.getElementById("includes");
		this.SizeChart = document.getElementById("sizeChart");

		if (this.Description !== null && this.DescriptionContainerMobile !== null && this.DescriptionContainerDesktop !== null)
		{
			enquire.register(Media.MediaDesktop, {
				deferSetup: true,
				match: () =>
				{
					this.LayoutDesktop();
				},
				unmatch: () =>
				{
					this.LayoutMobile();
				}
			});
		}
	}

	private LayoutDesktop = (): void =>
	{
		if (this.DescriptionContainerDesktop !== null && this.Description !== null)
		{
			this.DescriptionContainerDesktop.appendChild(this.Description);

			if (this.Includes !== null)
			{
				this.Includes.addEventListener(this.CollapseEvent, this.PreventCollapse);
			}

			if (this.SizeChart !== null)
			{
				this.SizeChart.addEventListener(this.CollapseEvent, this.PreventCollapse);
			}
		}
	};

	private LayoutMobile = (): void =>
	{
		if (this.DescriptionContainerMobile !== null && this.Description !== null)
		{
			this.DescriptionContainerMobile.appendChild(this.Description);

			if (this.Includes !== null)
			{
				this.Includes.removeEventListener(this.CollapseEvent, this.PreventCollapse);
			}

			if (this.SizeChart !== null)
			{
				this.SizeChart.removeEventListener(this.CollapseEvent, this.PreventCollapse);
			}
		}
	};

	private PreventCollapse = (e: Event): void =>
	{
		e.preventDefault();
	};
}